import { FC } from 'react';

import { Box } from '@mui/material';

import { TSelectOption } from 'shared/services/types/common.types';
import { FilterItemDate } from 'shared/ui/filter-item-date';
import { Input } from 'shared/ui/input';
import { SelectSearch } from 'shared/ui/select-multi';

interface IProps {
  accSorted: TSelectOption[];
  isAccountsLoading: boolean;
  usersSorted: TSelectOption[];
  isUsersLoading: boolean;
}

export const WithdrawalFields: FC<IProps> = ({
  accSorted,
  isAccountsLoading,
  usersSorted,
  isUsersLoading
}) => {
  return (
    <>
      <Box sx={{ minWidth: '19%' }}>
        <Input name='amount' label='Amount' placeholder='Enter amount' />
      </Box>
      <Box sx={{ minWidth: '19%' }}>
        <SelectSearch
          isMulti
          inputLabel='Account from'
          inputPlaceholder='Choose account from'
          name='account_id_from'
          options={accSorted}
          isOptionsLoading={isAccountsLoading}
        />
      </Box>
      <Box sx={{ minWidth: '19%' }}>
        <SelectSearch
          inputLabel='Account to'
          inputPlaceholder='Choose account to'
          name='account_id_to'
          options={accSorted}
          isOptionsLoading={isAccountsLoading}
        />
      </Box>
      <Box sx={{ minWidth: '19%' }}>
        <SelectSearch
          inputLabel='User'
          inputPlaceholder='Choose user'
          name='user_id'
          options={usersSorted}
          isOptionsLoading={isUsersLoading}
        />
      </Box>
      <Box sx={{ minWidth: '19%' }}>
        <FilterItemDate labelText='Created at' mono />
      </Box>
    </>
  );
};
